export default function hobbiesStore(store = [''], action) {

    if ( action.type === "GET-INIT-HOBBIES" ) {

        return action.payload
    }

    return store;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/HobbyReducer.js